var resourceAttributes = {};
export var setResourceAttributes = function (attributes) {
    resourceAttributes = attributes;
};
export var getResourceAttributes = function () {
    return resourceAttributes;
};
//# sourceMappingURL=set-resource-attributes.js.map